import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-48" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-51" data-mp="57ebob4uv5ec">
            <span aria-hidden="true" data-id="element-52" data-mp="3mfsxp4dt4r2a">📈 </span>The ACCOUNTING READY™ Difference
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-53" data-mp="3ri0eq8dhuxbh">
            From an exhausted teacher to a{' '}
            <span className="italic text-brand" data-id="element-54" data-mp="3iez7u5gt126r">confident guide.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-55" data-mp="1bpknr6kj7f4i">
            Give your lessons an operational impact, give your students mastery over bookkeeping,
            and give yourself the time to enjoy teaching again.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-56" data-mp="1f9k19ziifmr7">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-57" data-mp="1t2t7xsf2pu61" data-mpi={index}>
              <dt className="sr-only" data-id="element-58" data-mp="wazg0o3avblh">{stat.label}</dt>
              <dd data-id="element-59" data-mp="wcivich4tim7">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-60" data-mp="wd2e7velwb1a">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-61" data-mp="15b4m8uwrc3y2">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-62" data-mp="2gprmgkjmus1b">
          <div className="grid md:grid-cols-2" data-id="element-63" data-mp="2os0o2o1cg10k">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-64" data-mp="2otbs8oypbas7">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-65" data-mp="2srj5vaxvbvz6">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-66" data-mp="2xq479douwlp7" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-67" data-mp="32oxlx9fvqiqy">
                Before Accounting Ready™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-68" data-mp="2a1kw8qef9utf">
                The cost of improvisation
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-69" data-mp="2jsfm04qvncjm">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-70" data-mp="1mda6aia9lfjx">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-71" data-mp="1js2cv13w1024" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-72" data-mp="19u66emlwatac">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-73" data-mp="19sbhkx7i6h0z">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-74" data-mp="10t7xbpwlnvkw" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-75" data-mp="w2rm8cg94m1p">
                With Accounting Ready™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-76" data-mp="r46iw45pdm91">
                The ultimate system
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-77" data-mp="h4foe2h5778y">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-78" data-mp="d3nfxbg3h6dq">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-79" data-mp="16tw9n5cae5gh" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-80" data-mp="x2ibb0w2nbox">
            A complete system to plan less and teach with more passion.
          </p>
        </div>
      </div>
    </section>;
}